<template>
  <div class="w-full">
    <div class="flex flex-row justify-between mb-8 font-medium">
      <div class="flex flex-row items-center">
        <el-select
          v-model="filter"
          placeholder="Filter"
          size="mini"
          class="mr-4"
          clearable
          style="max-width: 150px;"
        >
          <el-option
            v-for="item in filterOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <span style="float: left">{{ item.label }}</span>
          </el-option>
        </el-select>
        <el-select
          v-model="engagement"
          placeholder="Engagement"
          size="mini"
          class="mr-12"
          clearable
          style="max-width: 260px; width: 260px;"
        >
          <el-option
            v-for="item in engagementOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="flex flex-row items-center">
        <el-input
          v-model="search"
          placeholder="Search Recipients"
          size="mini"
          class="flex mr-4"
          style="max-width: 200px"
        />
        <el-button
          size="mini"
          icon="el-icon-download"
          :loading="exporting"
          @click="exportRecipients"
          >{{ exporting ? "Exporting..." : "Export" }}</el-button
        >
      </div>
    </div>
    <RecipientsTable
      :communication="communication"
      :filterByEmail="search"
      :filterByEvent="filter"
      :filterByRead="engagementFilter.read"
      :filterByEmailOpened="engagementFilter.emailOpened"
    />
  </div>
</template>

<script>
import { exportCommunicationRecipients } from "./exportCommunicationRecipients";

//* "opened" is the email (a SendGrid open or click); "read" is the in-app
//* notification, marked read when the recipient views it
const ENGAGEMENT_OPTIONS = [
  {
    label: "Email not opened, in-app not read",
    value: "notOpenedNotRead",
    emailOpened: "false",
    read: "false"
  },
  {
    label: "Email not opened, in-app read",
    value: "notOpenedRead",
    emailOpened: "false",
    read: "true"
  },
  {
    label: "Email opened, in-app not read",
    value: "openedNotRead",
    emailOpened: "true",
    read: "false"
  },
  {
    label: "Email opened, in-app read",
    value: "openedRead",
    emailOpened: "true",
    read: "true"
  },
  {
    label: "In-app not read (any email)",
    value: "inAppNotRead",
    emailOpened: "",
    read: "false"
  }
];

const NO_ENGAGEMENT_FILTER = { label: "", emailOpened: "", read: "" };

export default {
  components: {
    RecipientsTable: () => import("./RecipientsTable.vue")
  },
  props: {
    communication: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      search: "",
      filter: "",
      engagement: "",
      exporting: false,
      filterOptions: [
        { label: "Processed", value: "processed" },
        { label: "Delivered", value: "delivered" },
        { label: "Open", value: "open" },
        { label: "Click", value: "click" },
        { label: "Bounce", value: "bounce" },
        { label: "Dropped", value: "dropped" }
      ],
      engagementOptions: ENGAGEMENT_OPTIONS
    };
  },
  computed: {
    engagementFilter() {
      return (
        ENGAGEMENT_OPTIONS.find(option => option.value === this.engagement) ||
        NO_ENGAGEMENT_FILTER
      );
    }
  },
  methods: {
    async exportRecipients() {
      if (this.exporting) return;
      this.exporting = true;
      try {
        await exportCommunicationRecipients({
          communicationId: this.$route.params.communicationId,
          communicationTitle: this.communication.title,
          event: this.filter,
          read: this.engagementFilter.read,
          emailOpened: this.engagementFilter.emailOpened,
          engagementLabel: this.engagementFilter.label,
          email: this.search
        });
      } catch (error) {
        this.$appNotifyError("Failed to export communication recipients");
        this.$bugSnagClient.notify(error);
      } finally {
        this.exporting = false;
      }
    }
  }
};
</script>

<style scoped></style>
